// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_itK","cls2":"common-cls2_UyM common-cls1_itK"};